import { render, staticRenderFns } from "./ChallengeFinished.vue?vue&type=template&id=ac51a234&scoped=true"
import script from "./ChallengeFinished.vue?vue&type=script&lang=ts"
export * from "./ChallengeFinished.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac51a234",
  null
  
)

export default component.exports